import { render, staticRenderFns } from "./rankingModule.vue?vue&type=template&id=13935662&scoped=true"
import script from "./rankingModule.vue?vue&type=script&lang=js"
export * from "./rankingModule.vue?vue&type=script&lang=js"
import style0 from "./rankingModule.vue?vue&type=style&index=0&id=13935662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13935662",
  null
  
)

export default component.exports